import { Skeleton } from '@opaz/ui-components';
import { SubNavContainer } from './sub-nav-container';
import { Container } from './container';

type PageLoadingProps = {
  showNav?: boolean;
};

export const PageLoading = ({ showNav = false }: PageLoadingProps) => {
  return (
    <>
      {showNav && (
        <div className="flex h-[72px] border-b-2 items-center px-3">
          <Skeleton className="mx-auto max-w-[960px] h-[40px] w-full" />
        </div>
      )}

      <SubNavContainer isLoading>
        <Skeleton className="h-[75px] w-full" />
      </SubNavContainer>

      <Container>
        <div className="flex flex-col items-center justify-center h-full w-full gap-4">
          <Skeleton className="h-[400px] w-full" />
        </div>
      </Container>
    </>
  );
};
